import classNames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import * as React from 'react';
import { Icon, IconName } from 'palette/Icon';
import { Transition } from 'palette/Transition';
import { Small } from 'palette/Typography';
import './styles/HeaderDropdown.scss';

type HeaderDropdownProps = React.PropsWithChildren<{
    id?: string;
    isOpen: boolean;
    children: React.ReactNode;
    footerData: {
        iconName: IconName;
        label: string;
    }[];
    className?: string;
    ariaLabel?: string;
}>;

function HeaderDropdown({
    id,
    isOpen,
    children,
    footerData,
    className,
    ariaLabel,
}: HeaderDropdownProps) {
    const [block, BEMElement] = BEMBlock('header-dropdown');
    const classes = classNames(block, className);

    return (
        <Transition
            appear
            className={classes}
            property="opacity"
            show={isOpen}
            timeout="slow"
        >

            <div
                aria-label={ariaLabel}
                id={id}
            >
                <div className={BEMElement('body')}>
                    {children}
                </div>
                {isOpen ? (
                    <footer className={BEMElement('footer')}>
                        {footerData.map(footerDataEntry => (
                            <div
                                key={footerDataEntry.label}
                                className={BEMElement('footer-usp')}
                            >
                                <Icon
                                    className={BEMElement('footer-usp-icon')}
                                    color="black"
                                    name={footerDataEntry.iconName}
                                    strokeWidth="thin"
                                />
                                <Small color="strong">
                                    {/* eslint-disable-next-line react/no-danger */}
                                    <span dangerouslySetInnerHTML={{ __html: footerDataEntry.label }} />
                                </Small>
                            </div>
                        ))}
                    </footer>
                ) : null}
            </div>
        </Transition>
    );
}

export default HeaderDropdown;
